export default class SingleProduct {
    constructor() {
        this.buttons = document.getElementById("sp-qty-buttons");

        if (this.buttons) {
            this.changeQuantityButton();
        }
    }

    changeQuantityButton() {
        this.buttons
            .querySelectorAll(".single-product__attributes__attribute")
            .forEach((el) => {
                el.addEventListener("click", (e) => {
                    const active = this.buttons.querySelector(".btn--black");
                    if (el) {
                        if (active) {
                            active.classList.add("btn--black-transparent");
                            active.classList.remove("btn--black");
                            active.classList.remove("js-active");
                        }
                        e.target.classList.remove("btn--black-transparent");
                        e.target.classList.add("btn--black");
                        e.target.classList.add("js-active");
                    }
                });
            });
    }
}
